/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoCategoryInfomation,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoCategoryInfomationFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoCategoryInfomationFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoCategoryInfomationToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoCategoryInfomation';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfo
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfo {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfo
     */
    menuNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfo
     */
    menuNm?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfo
     */
    planNm?: string;
    /**
     * 
     * @type {JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoCategoryInfomation}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfo
     */
    categoryInfomation?: JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoCategoryInfomation;
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfo {
    return JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'menuNo': !exists(json, 'menuNo') ? undefined : json['menuNo'],
        'menuNm': !exists(json, 'menuNm') ? undefined : json['menuNm'],
        'planNm': !exists(json, 'planNm') ? undefined : json['planNm'],
        'categoryInfomation': !exists(json, 'categoryInfomation') ? undefined : JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoCategoryInfomationFromJSON(json['categoryInfomation']),
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'menuNo': value.menuNo,
        'menuNm': value.menuNm,
        'planNm': value.planNm,
        'categoryInfomation': JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseMenuBasicInfoCategoryInfomationToJSON(value.categoryInfomation),
    };
}

